import "./brands.scss";


(function($) {
  $(document).ready(function() {
    if ($('#product-brands-content').length) {
      let swiperBrands = new Swiper('#product-brands-content', { // eslint-disable-line
        wrapperClass: 'brands',
        slideClass: 'brands__item',
        spaceBetween: 20,
        slidesPerView: 5,
        speed: 600,
        navigation: {
          nextEl: '.brands__next',
          prevEl: '.brands__prev',
        },
        breakpoints: {
          320: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 4
          }
        }
      });
    }
  });
})(jQuery);
